import {listAuthClients} from './listAuthClients'
import {exchange} from './exchange'
import {logout} from './logout'
import {refresh} from './refresh'

export const auth = {
  exchange,
  listAuthClients,
  logout,
  refresh,
}
